import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {CommonModal} from 'components/common';
import OrderTable from './OrderTable';
import OrderCreation from './OrderCreation';
import OrderUpdate from './OrderUpdate';
import {deleteOrder} from 'api';
import {fetchOrders, setCurrentOrderPage, setCurrentOrder, clearOrdersAfterPage} from 'actions/orders';
import {formatErrors} from 'actions/errors';
import {addFlashMessage} from 'actions/flash-message';

class OrderList extends React.Component {
  static propTypes = {
    orderPages: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      createModalShown: false,
      updateModalShown: false,
      refreshTableKey: 0,
      currentOrder: null,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleCreationSuccess = this.handleCreationSuccess.bind(this);
    this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
    this.deleteOrder = this.deleteOrder.bind(this);
  }

  showModal(type, currentOrder) {
    this.setState({
      [`${type}ModalShown`]: true,
      currentOrder,
    });
  }

  closeModal(type) {
    this.setState({
      [`${type}ModalShown`]: false,
      currentOrder: null,
    });
  }

  handleCreationSuccess() {
    this.setState((prevState) => ({
      createModalShown: false,
      refreshTableKey: prevState.refreshTableKey + 1,
    }));
  }

  handleUpdateSuccess() {
    this.setState((prevState) => ({
      updateModalShown: false,
      refreshTableKey: prevState.refreshTableKey + 1,
      currentOrder: null,
    }));
  }

  deleteOrder(record) {
    const {addFlashMessage, formatErrors} = this.props;
    deleteOrder(record.id)
      .then(() => {
        this.setState((prevState) => ({
          refreshTableKey: prevState.refreshTableKey + 1,
        }));
        addFlashMessage('The order has been successfully deleted!', 'success');
      })
      .catch((err) => formatErrors(err));
  }

  render() {
    const {createModalShown, updateModalShown, refreshTableKey, currentOrder} = this.state;
    const {orderPages, fetchOrders, setCurrentOrderPage, setCurrentOrder, clearOrdersAfterPage} = this.props;
    return (
      <div>
        <CommonModal title="Create New Order" onClose={() => this.closeModal('create')} show={createModalShown}>
          <OrderCreation onSubmitSuccess={this.handleCreationSuccess} />
        </CommonModal>
        <CommonModal title="Edit Order" onClose={() => this.closeModal('update')} show={updateModalShown}>
          <OrderUpdate order={currentOrder} onSubmitSuccess={this.handleUpdateSuccess} />
        </CommonModal>
        <div className="container content-box">
          <Panel>
            <h3 className="section-header">
              <div className="section-title">Orders</div>
              <Button
                variant="contained"
                color="primary"
                className="pull-right"
                onClick={() => this.showModal('create')}
              >
                Purchase Order
              </Button>
            </h3>
            <OrderTable
              {...{
                refreshTableKey,
                recordPages: orderPages,
                fetchRecords: (q, page, perPage, sortOpts, extraFilters = {}) =>
                  fetchOrders(q, page, perPage, sortOpts, {...extraFilters, summary: true}),
                setCurrentRecordPage: setCurrentOrderPage,
                setCurrentRecord: setCurrentOrder,
                clearRecordsAfterPage: clearOrdersAfterPage,
                showUpdateModal: (record) => this.showModal('update', record),
                onDeleteActionClick: this.deleteOrder,
              }}
            />
          </Panel>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  orderPages: state.orders.get('orderPages').toJS(),
});

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
  fetchOrders: (...args) => dispatch(fetchOrders(...args)),
  setCurrentOrderPage: (...args) => dispatch(setCurrentOrderPage(...args)),
  setCurrentOrder: (...args) => dispatch(setCurrentOrder(...args)),
  clearOrdersAfterPage: (...args) => dispatch(clearOrdersAfterPage(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderList);
